import { get } from '@/helpers/httpHandler';
import { echo, defaultChannel } from '@/helpers/pusher';

export default {
  getQuantity({ commit }) {
    return get(`/inhabitant-changes/quantity-status-new`).then(response => {
      commit(
        'setInhabitantChange',
        response.data.quantity_new_inhabitant_changes
      );
      return response;
    });
  },

  getActualQuantity({ commit }) {
    echo
      .channel(defaultChannel)
      .listen(
        '.App\\Events\\InhabitantChange\\NewInhabitantChangeCountEvent',
        function(data) {
          commit('setInhabitantChange', data.quantity_new_inhabitant_changes);
        }
      );
  }
};
